import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form, Space, Row, Col, Button, Upload, message } from "antd";
import { InputCustom } from "../componentes/inputComponent";
import { TablaCompleta } from "../tablas/tabla_simple";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import { PlusOutlined } from "@ant-design/icons";
import { manejarError } from "../manejo_errores";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { HeadersAuth } from "../funciones_utiles";
import { BotonPrincipal } from "../componentes/btnPrincipal";

import { useMediaQuery } from "react-responsive";
import { ModalNotificacion } from "../componentes/modalNotificacion";

export const AltaCircuito = ({ sesion, setAlerta }) => {
  const manejarAlertas = (tipo, mensaje) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  };
  const MySwal = withReactContent(Swal);
  const [tempDatosFormulario, setTempDatosFormulario] = useState({
    nombre: "",
    localidad: "",
    imagen: null,
  });
  const [fetchDatos, setFetchDatos] = useState([]);
  const [refresh, setRefresh] = useState("");
  const [idUnico, setIdUnico] = useState(null);
  const [previewImage, setPreviewImage] = useState("");
  const [mostrarBotonLimpiar, setMostrarBotonLimpiar] = useState(false);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [abrirModalNotificacion, setAbrirModalNotificacion] = useState(false);
  const [eliminarId, setEliminarId] = useState(null);
  const [dataNotificacion, setDataNotificacion] = useState([]);

  // Carga inicial de datos
  useEffect(() => {
    fetchCircuitos(sesion.id_asociacion);
  }, [refresh]);

  const fetchCircuitos = async (id_asociacion) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/circuito/asociacion/${id_asociacion}`,
        HeadersAuth
      );
      if (response.status === 200 && Array.isArray(response.data)) {
        setFetchDatos(response.data);
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error))
      // manejarError(error);
    }
  };

  const handleEdit = async (id) => {
    try {
      const URI_CIRCUITO = `${process.env.REACT_APP_DOMINIO}/circuito/${id}`;
      const datosCircuito = await axios.get(URI_CIRCUITO, HeadersAuth);
      if (datosCircuito.status === 200) {


        setTempDatosFormulario({
          nombre: datosCircuito.data.nombre,
          localidad: datosCircuito.data.localidad,
          imagen: null,
        });
        // console.log(datosCircuito.data);
        if (datosCircuito.data.imagen) {
          setPreviewImage(
            `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${sesion.id_asociacion}/IMAGENES/CIRCUITOS/${datosCircuito.data.imagen}`
          );
        } else {
          setPreviewImage(``);
        }
        setIdUnico(id);
        setMostrarFormulario(true);
        setMostrarBotonLimpiar(true);
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error))
      // manejarError(error);
    }
  };

  const guardarCircuito = async () => {
    try {
      let url = idUnico
        ? `${process.env.REACT_APP_DOMINIO}/circuito/${idUnico}`
        : `${process.env.REACT_APP_DOMINIO}/circuito`;

      const formData = new FormData();
      formData.append("nombre", tempDatosFormulario.nombre);
      formData.append("localidad", tempDatosFormulario.localidad);
      formData.append("imagen", tempDatosFormulario.imagen);

      const response = idUnico
        ? await axios.put(url, formData, HeadersAuth)
        : await axios.post(url, formData, HeadersAuth);

      if (response.status === 200) {
        manejarAlertas("success", "Guardado exitoso")

        limpiarCampos();
        setRefresh(Date.now());
        setMostrarFormulario(false);
        setMostrarBotonLimpiar(false);

        if (response.data.requiereNotificacion) {
          setAbrirModalNotificacion(true)
          setDataNotificacion(response.data.notificacionSistema);
        }
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error))

    }
  };

  const handleEliminarCircuito = (id) => {
    MySwal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_DOMINIO}/circuito/pre-eliminar/${id}`,
            HeadersAuth
          );
          // console.log("Pre Eliminación:", response.data);

          // Si requiere notificación → abrir modal ANTES de eliminar
          if (response.data.requiereNotificacion) {
            setAbrirModalNotificacion(true);
            setDataNotificacion(response.data.notificacionSistema); 

            // Guardamos ID para eliminar luego
            setEliminarId(id);
            return;
          }

          // Si NO requiere notificación → eliminar directamente
          await eliminarCircuito(id);
        } catch (error) {
          manejarAlertas("error", manejarError(error))

        }
      }
    });
  };

  useEffect(() => {
    if (!abrirModalNotificacion && eliminarId) {
      eliminarCircuito(eliminarId);
      setEliminarId(null);
    }
  }, [abrirModalNotificacion]);

  const eliminarCircuito = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_DOMINIO}/circuito/${id}`,
        HeadersAuth
      );

      manejarAlertas("success", "El circuito ha sido eliminado.");
      setRefresh(Date.now());

    } catch (error) {
      console.error("Error al eliminar el circuito:", error);
      manejarAlertas("error", manejarError(error));
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setTempDatosFormulario((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files && e.target.files[0];

    if (file) {
      // Validar que el archivo sea una imagen
      if (!file.type.startsWith("image/")) {
        manejarAlertas("error", "El archivo seleccionado no es una imagen válida.(JPG, JPEG, PNG)")


        return;
      }

      // Convertir el archivo a Base64
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result; // Resultado en Base64

        // Actualiza el estado del formulario con el Base64
        setTempDatosFormulario((prev) => ({
          ...prev,
          imagen: base64String, // Guarda la imagen en Base64
        }));

        // Genera una vista previa de la imagen
        setPreviewImage(base64String);
      };
      reader.readAsDataURL(file); // Convierte el archivo a Base64
    } else {


      manejarAlertas("error", "No se seleccionó ningún archivo válido.")


    }
  };

  const limpiarCampos = () => {
    setTempDatosFormulario({
      nombre: "",
      localidad: "",
      imagen: null,
    });
    setIdUnico(null);
    setPreviewImage("");
    setMostrarBotonLimpiar(false);
  };
  const elScroll = { x: 0 };
  const columns = [
    {
      title: "NOMBRE",
      dataIndex: "nombre",
      key: "nombre",
      align: "left",
    },
    {
      title: "LOCALIDAD",
      dataIndex: "localidad",
      key: "localidad",
      align: "left",
    },
    {
      title: "OPCIONES",
      key: "opciones",
      align: "center",
      render: (_, record) => (
        <>
          <FaRegEdit
            className="iconos-tablas"
            style={{ color: "blue", cursor: "pointer", marginRight: "10px" }}
            onClick={() => handleEdit(record.id)}
          />
          <FaRegTrashAlt
            className="iconos-tablas"
            style={{ color: "red", cursor: "pointer" }}
            onClick={() => handleEliminarCircuito(record.id)}
          />
        </>
      ),
    },
  ];
  const esTelefono = useMediaQuery({ maxWidth: 768 });
  // Función para mostrar el formulario y ocultar el botón
  const mostrarFormularioHandler = () => {
    setMostrarFormulario(true);
  };
  return (
    <>
      <section
        id="seccionPiloto"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1em",
        }}
      >
        <h1 className="titulos">Gestión de circuitos</h1>
      </section>
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "1200px",
            padding: "20px",
            margin: "0 auto",
          }}
        >
          {mostrarFormulario && (
            <Form layout="vertical" onFinish={guardarCircuito}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "1em",
                }}
              >
                <h1 className="titulos-secundarios">Datos del circuito</h1>
                {mostrarBotonLimpiar && (
                  <BotonPrincipal
                    texto="Nuevo circuito"
                    onClick={limpiarCampos}
                  />
                )}
              </div>
              <hr />
              <Row gutter={16} align="middle">
                <Col xs={24} sm={6}>
                  <Form.Item
                    style={{
                      width: "100%",
                      // maxWidth: "300px"
                    }}
                  >
                    <InputCustom
                      tipo="text"
                      nombreCampo="Nombre"
                      idCampo="nombre"
                      elPlaceholder="Ingrese el nombre del circuito"
                      elValue={tempDatosFormulario.nombre || ""}
                      onChange={handleChange}
                      required={true}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={6}>
                  <Form.Item
                    style={{
                      width: "100%",
                      // maxWidth: "300px"
                    }}
                  >
                    <InputCustom
                      tipo="text"
                      nombreCampo="Localidad"
                      idCampo="localidad"
                      elPlaceholder="Ingrese la localidad"
                      elValue={tempDatosFormulario.localidad || ""}
                      onChange={handleChange}
                      required={true}
                    />
                  </Form.Item>
                </Col>
                <Col 
                  xs={24} sm={6}
                  className="colMostrarForm"
                  style={{ 
                    display: "flex",
                    flexDirection: "row",
                    gap: 20,
                    width: "100%",
                  }}
                >
                  <Form.Item
                    style={{
                      width: "100%",
                    }}
                  >
                    {/* Contenedor principal */}
                    <div
                      style={{
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      {/* Botón personalizado */}
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          width: "100%"
                        }}
                      >
                        <label
                          htmlFor="image-upload"
                          style={{
                            display: "flex",
                            height: 30,
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#223463",
                            color: "#fff",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "16px",
                            border: "none",
                            outline: "none",
                            transition: "background-color 0.3s ease",
                            marginTop: "1.4em",
                            padding: "5px 20px",
                          }}
                        >
                          {/* Icono de flecha hacia arriba */}
                          <span style={{ marginRight: "10px" }}>↑</span>
                          {/* Línea vertical */}
                          <span
                            style={{
                              height: "30px",
                              width: "0.5px",
                              backgroundColor: "#fff",
                              margin: "0 10px",
                            }}
                          ></span>
                          {/* Texto fijo */}
                          Subir imagen
                        </label>
                        {/* Input de archivo oculto */}
                        <input
                          id="image-upload"
                          type="file"
                          accept=".jpg,.jpeg,.png" // Solo permite imágenes JPG, JPEG y PNG
                          onChange={handleImageChange} // Manejador para procesar el archivo seleccionado
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
              <Row 
                gutter={16} 
                align="middle"
                className="rowBotonForm"
              >
                {/* Cuarta columna: Botón de acción */}
                <Col xs={24} sm={12} className="botonesResponsive"
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}>
                  <Form.Item
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      height: "100%",
                    }}
                  >
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="boton-principal"
                      style={{
                        width: "100%", //
                      }}
                    >
                      {idUnico ? "Actualizar" : "Guardar"}
                    </Button>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={6}>
                  {/* Contenedor de la imagen previa */}
                  {previewImage && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={previewImage}
                        alt="Vista previa"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "8px", // Añade bordes redondeados para un diseño más moderno
                          border: "1px solid #ddd", // Agrega un borde sutil para destacar la imagen
                        }}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </Form>
          )}
        </div>
      </section>
      <div
        className="botonDescargar"
        style={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          alignContent: "center",
          justifyContent: "center",
          alignItems: "flex-end",
           padding:"0 16px"
        }}
      >
        <br></br>
        <TablaCompleta
          tituloPDF={"circuitos"}
          elScroll={elScroll}
          mostrarBoton={false}
          columns={columns}
          fetchDatos={fetchDatos.length > 0 ? fetchDatos : []}
          rowKey={"id"}
          gestionTabla={
            <Row style={{ gap: "10px" }}>
              {!mostrarFormulario && (
                <BotonPrincipal
                  texto={esTelefono ? <PlusOutlined /> : "Agregar"}
                  onClick={mostrarFormularioHandler}
                />
              )}
            </Row>
          }
          mostrarBotonDescargar={false}
        />
      </div>
      {dataNotificacion.length > 0 && (
        <ModalNotificacion
          open={abrirModalNotificacion}
          onCancel={() => setAbrirModalNotificacion(false)}
          datos={dataNotificacion}
          id_asociacion={sesion.id_asociacion}
          HeadersAuth={HeadersAuth}
          setAlerta={setAlerta}
        />
      )}
    </>
  );
};
